import { forwardRef } from "react";
import { IMaskInput, IMaskInputProps } from "react-imask";

type MaskedInputProps = IMaskInputProps<HTMLInputElement> & {
  onChange?: (value: string) => void;
};

export const DefaultMaskedInput = forwardRef<
  HTMLInputElement,
  MaskedInputProps
>(({ onChange, ...props }, ref) => (
  <IMaskInput
    {...props}
    ref={ref}
    onAccept={(value, mask, context) => {
      onChange?.(value);
      props?.onAccept?.(value, mask, context);
    }}
    onChange={onChange}
  />
));
